import PaymentTransaction from './PaymentTransaction';

export default class AuthTransaction extends PaymentTransaction {
	
}